// extracted by mini-css-extract-plugin
export default {"zolaLoader":"zolaLoader__2mQsu","petal":"petal__2oLYO","spin":"spin__1rTU_"};